/**
 * Input Schema of Faturamento
 * @author Thacryba
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import SearchResponsavel from '@/components/SearchResponsavel.vue'
import {ResponsavelGrupoParceiro} from '@/model/resource/ResponsavelGrupoParceiro'

export class InputResponsavelGrupoParceiroSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  formFields = ['parceiroPermitido']

  readonly name = 'InputResponsavelGrupoParceiro'

  readonly fieldSet: FieldSet<ResponsavelGrupoParceiro> = {
    parceiroPermitido: (schema): FieldComponent => ({
      is: SearchResponsavel,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionResponsavel,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
      },
    }),
  }
}
